import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import { Link } from "react-router-dom";
import NavBar from "../../Components/NavBar";
import Cookies from "js-cookie";

function AllBlogs({ initialData = {}, language }) {
    const [currentPage, setCurrentPage] = useState(1);
    const [blogs, setBlogs] = useState(initialData?.blogs?.data || []);
    const [allBlogs, setAllBlogs] = useState(initialData?.blogs?.data || []);
    const [searchTerm, setSearchTerm] = useState("");

    const totalPages = 11;

    useEffect(() => {
        if (initialData?.blogs === undefined) {
            const fetchBlogs = async () => {
                try {
                    const response = await fetch(`https://admin.hopdays.com/api/blogs`);
                    const data = await response.json();
                    setBlogs(data.data);
                    setAllBlogs(data.data);
                } catch (error) {
                    console.error("Error fetching blogs:", error);
                }
            };
            fetchBlogs();
        }
    }, [initialData]);

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);

        if (value.trim() === "") {
            setBlogs(allBlogs);
        } else {
            const filtered = allBlogs.filter(blog =>
                blog.title.toLowerCase().includes(value.toLowerCase())
            );
            setBlogs(filtered);
        }
    };

    return (
        <>
            <NavBar language={language || Cookies.get("lang")} />
            <div className="px-4 md:px-16 py-8">
                <div className="text-gray-500 text-sm mb-4">Home {">"} Inspire</div>

                <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-8">
                    <div className="font-medium text-gray-600">{blogs.length} results</div>
                    <div className="relative w-full md:w-1/3">
                        <SearchIcon className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                        <input
                            type="text"
                            placeholder="Search inspire..."
                            value={searchTerm}
                            onChange={handleSearchChange}
                            className="w-full py-2 pl-4 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                        />
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
                    {blogs?.map((blog) => (
                        <div
                            key={blog?._id}
                            className="bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 "
                        >
                            {blog?.headerImage && (
                                <img
                                    src={blog?.headerImage[0]?.thumbUrl}
                                    alt="Blog Cover"
                                    className="w-full h-60 object-cover"
                                />
                            )}
                            <div className="p-4 flex  justify-between">
                                <div>
                                    <h3 className="text-lg font-semibold text-gray-800 line-clamp-2">{blog?.title}</h3>
                                    <p className="text-gray-500 text-sm mt-2 line-clamp-3">{blog?.subDescription}</p>
                                </div>
                                <div>
                                    <Link
                                        to={`/${language === "ar" ? "ar" : "en"}/inspire/${blog?.countryData?.name?.toLocaleLowerCase().replace(/\s+/g, '-')}/${blog?.slug?.toLocaleLowerCase().replace(/\s+/g, '-') || "slug"}-${blog?._id}`}
                                        className="inline-flex items-center gap-1 text-blue-500 hover:underline text-sm"
                                    >
                                        Read More <ArrowForwardOutlinedIcon fontSize="small" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}

export default AllBlogs;
